<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-img src="https://i.imgur.com/cCTibpN.jpg" max-height="80vh" contain></v-img>
      </v-col>
      <v-col cols="6">
        <v-row justify="center">
          <v-col cols="12">
            <div class="text-center text-h4">Welcome to TS Porn Roulette!</div>
            <div class="text-center text-subtitle-2">In this roulette, we will be rolling through a number of videos to see what you will be jerking off to today!</div>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn @click="roll">Roll!</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!this.$vuetify.breakpoint.smAndDown" justify="center">
          <v-container
            id="scroll-target"
            style="max-height: 50vh"
            class="overflow-y-auto mt-3"
          >
            <v-row justify="center">
              <iframe :src="vidSrc" frameborder="0" width="560" height="315" scrolling="no" allowfullscreen></iframe>
            </v-row>
          </v-container>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="this.$vuetify.breakpoint.smAndDown">
        <v-container
        id="scroll-target"
        style="max-height: 50vh"
        class="overflow-y-auto mt-3"
      >
        <v-row justify="center">
          <iframe :src="vidSrc" frameborder="0" width="560" height="315" scrolling="no" allowfullscreen></iframe>
        </v-row>
      </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

    export default {
      name: 'tspornroulette',
      components: {

      },
      data: () => ({
        videos: [
          "ph5efa4dbe3e9e5",
          "ph5e949406c4f7b",
          "ph5efd62400b1dd",
          "ph5f2167822bcd8",
          "ph5f2372f38d8d1",
          "ph5f267461ba490",
          "ph5efa4d1bc5ca3",
          "ph597bf6f5e1c27",
          "ph5998103d11e8f",
          "ph5de7db73e9af1",
          "ph5f295d699ffaa",
          "ph5f2a40011bb8f",
          "ph56e2f7050d7d5",
          "ph5efe27b10c5b7",
          "ph5ee6b6308986b",
          "ph5ba3acb04a0cd",
          "ph5bfc4a0fe3b27",
          "ph5ba3acb017230",
          "ph5c3d726549f0c",
          "ph5bd3961b3330b",
          "ph59e27dcc403e8",
          "ph59d5ca2925b30",
        ],
        vidSrc: ""
      }),
      methods: {
        roll() {
          let randomIndex = Math.floor(Math.random() * this.videos.length);
          this.vidSrc = "https://www.pornhub.com/embed/" + this.videos[randomIndex];
        }
      },
    }
</script>